(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[153],{

/***/ 5941:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/produk",
      function () {
        return __webpack_require__(4774);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 4774:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7294);
/* harmony import */ var _components_big_Carousel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6765);
/* harmony import */ var _components_big_ProductCarousel__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(3787);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(3987);
/* harmony import */ var _components_big_CarouselMobile__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(8433);
/* eslint-disable react-hooks/rules-of-hooks */ 





var produk = function(param) {
    var titleData = param.titleData, productData = param.productData, dataOrmas = param.dataOrmas, filters = param.filters, bannerDataPc = param.bannerDataPc, bannerDataMobile = param.bannerDataMobile, secondProduct = param.secondProduct;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), second = ref[0], setSecond = ref[1];
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_components_Layout__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
        titlePage: "produk",
        titleData: titleData,
        dataOrmas: dataOrmas,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_big_Carousel__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                bannerDataPc: bannerDataPc
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_big_CarouselMobile__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                bannerDataMobile: bannerDataMobile
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
                className: "bg-white overflow-hidden keAtas",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "px-5 mt-4",
                        style: {
                            minHeight: 450
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "text-center text-black",
                                children: "Sesuai kan kemasan produk dengan kebutuhan Anda"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_big_ProductCarousel__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                productData: productData
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                className: "text-primary mt-5",
                                onClick: function() {
                                    return setSecond(!second);
                                },
                                style: {
                                    cursor: "pointer"
                                },
                                children: [
                                    second ? "Sembunyikan Produk lainya ".concat(titleData.judulFooter, " ...!") : "Tampilkan Produk lainya di ".concat(titleData.judulFooter, " ...!"),
                                    " "
                                ]
                            })
                        ]
                    }),
                    second ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "px-5",
                        style: {
                            minHeight: 450
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h2", {
                                className: "text-center text-black",
                                children: [
                                    "Second Produk Lainya di ",
                                    titleData.judulFooter,
                                    " :"
                                ]
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_big_ProductCarousel__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                productData: secondProduct
                            })
                        ]
                    }) : null,
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "container mb-5",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "row justify-content-center",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "col-md-6",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("h4", {
                                        className: "text-black",
                                        children: [
                                            "Kebijakan ",
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("i", {
                                                children: [
                                                    " ",
                                                    titleData.judulFooter
                                                ]
                                            }),
                                            " dalam Mengelolah PRODUK:"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                        className: "timeline",
                                        children: filters.map(function(filter) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                children: [
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                                        className: "text-black",
                                                        children: filter.name
                                                    }),
                                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                        className: "text-black",
                                                        children: filter.deskripsi
                                                    })
                                                ]
                                            }, filter._id);
                                        })
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        ]
    });
};
var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (produk);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [675,488,698,640,774,888,179], function() { return __webpack_exec__(5941); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);